export default {
    getConstans() {
        return {
            DEFAULT_TIMEZONE: "Asia/Ho_Chi_Minh",
            DB_TIMEZONE: "UTC",
            DB_FORMAT_DATE: "YYYY-MM-DD",
            STATE_ID_HCM:9,
            //flow quận huyện 
            OFF_DISTRICT:0,
            TYPE_STATE:{
                URBAN:1,//Nội thành
                OUTSIDE:2,//Ngoại thành
            },
            STATUS_DOCUMENT_WAITING:'WAITING',
            MSG_TEXT:{
                ERR_PLEASE_TRY_AGAIN:'Xin vui lòng thử lại',
            },
            DATE_VALUE:{
                dateReceiptCourt:null,
                dateTDVReturn:null,
                dateRequestComplete:null,
                dateReturnCourt:null,
                dateTDVReceipt:null,
                dateDPVReceipt:null,
                dateComplete:null,
                dateChangeTDV:null,
            },
            DATA_COMMON_UPDATE_CONFIRM_SALARY:
                {
                    is_full_salary: true,
                    is_confirm_salary: true,
                    date_comfirm_salary: (new Date()).toISOString()
                },
            LIST_OPTION_COMMON:{
                //TEXT_TOTAL_ITEM:'Tổng số dòng:',
                PER_PAGE_OPTIONS: [5, 10, 20, 50, 100,150],
               // PAGINATOR_TEMPLATE: 'CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown',
                //PAGINATION_ROWS_DEFAULT:20,
            }
        };
    }
}